import { FC } from 'react';

import { RouteComponentProps, Route, Redirect } from 'react-router-dom';

import { useAuth } from '~/hooks/auth';

interface RouteProps {
  component: FC<RouteComponentProps>;
  path: string;
  exact?: boolean;
  requiredRoles: string[];
}

const AppRoute: FC<RouteProps> = ({
  component: Component,
  path,
  exact = false,
  requiredRoles,
}): JSX.Element => {
  const { user } = useAuth();

  const isAuthenticated = !!user;

  const userHasRequiredRole = user?.role
    ? requiredRoles.includes(user?.role)
    : false;

  const message = userHasRequiredRole
    ? 'Please log in to view this page'
    : "You can't be here!";

  const options: { [key: string]: string } = {
    student: '/student/students',
    professional: '/professional/students',
    gym: '/gym/students',
  };

  return (
    <Route
      exact={exact}
      path={path}
      render={(props: RouteComponentProps) =>
        isAuthenticated && userHasRequiredRole ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: userHasRequiredRole
                ? options[user.role]
                : '/unauthorized',
              state: {
                message,
                requestPath: path,
              },
            }}
          />
        )
      }
    />
  );
};

export default AppRoute;
